module.exports = __webpack_public_path__ + "static/img/background.45335a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/background.png
// module id = 637
// module chunks = 70